export default __webpack_public_path__ + "static/media/redeem.e0b7ccd9.svg";